import ApiService from '../../services/api.service'
import { Notify } from 'quasar'

export const schedulerTimeslots = {
  state: {
    schedulerTimeslots: []
  },
  mutations: {
    setSchedulerTimeslots(state, timeslots) {
      state.schedulerTimeslots = timeslots
    },
    callbackAddSchedulerTimeslot(state, newTimeslot) {
      state.schedulerTimeslots.push(newTimeslot)
    },
    callbackUpdateSchedulerTimeslot(state, updatedTimeslot) {
      const index = state.schedulerTimeslots.findIndex(t => t.id === updatedTimeslot.id)
      if (index !== -1) {
        state.schedulerTimeslots.splice(index, 1, updatedTimeslot)
      }
    },
    callbackRemoveSchedulerTimeslot(state, timeslotId) {
      state.schedulerTimeslots = state.schedulerTimeslots.filter(t => t.id !== timeslotId)
    }
  },
  actions: {
    async fetchAllSchedulerTimeslots({ commit, rootState }, antenneIdPayload = null) {
      const antenneId = antenneIdPayload || rootState.auth.user.antenne.id;
      try {
        const response = await ApiService.getRequest(`/scheduler_time_slots?antenne=${antenneId}`)
        commit('setSchedulerTimeslots', response.data['hydra:member'])
        return Promise.resolve()
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Erreur lors de la récupération des plages horaires.",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },

    async addSchedulerTimeslot({ commit, rootState }, { timeslot, antenneId }) {
      const finalAntenneId = antenneId || rootState.auth.user.antenne.id;

      let antenneIdParam = finalAntenneId;
      if (typeof finalAntenneId === 'string' && finalAntenneId.includes('/antennes/')) {
          antenneIdParam = finalAntenneId.split('/').pop();
      }

      timeslot.antenne = `/antennes/${antenneIdParam}`;
      try {
        const response = await ApiService.postRequest('/scheduler_time_slots', timeslot)
        if (response.status === 201) {
          commit('callbackAddSchedulerTimeslot', response.data)
          Notify.create({
            message: 'La plage horaire a été ajoutée avec succès.',
            color: 'green'
          })
          return Promise.resolve(response.data)
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite lors de l'ajout.",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },

    async updateSchedulerTimeslot({ commit }, updatedTimeslot) {
      try {
        const response = await ApiService.patchRequest(
          `/scheduler_time_slots/${updatedTimeslot.id}`,
          updatedTimeslot
        )
        if (response.status === 200) {
          commit('callbackUpdateSchedulerTimeslot', response.data)
          Notify.create({
            message: 'La plage horaire a été mise à jour avec succès.',
            color: 'green'
          })
          return Promise.resolve(response.data)
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite lors de la mise à jour.",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },

    async deleteSchedulerTimeslot({ commit }, timeslotId) {
      try {
        const response = await ApiService.deleteRequest(
          `/scheduler_time_slots/${timeslotId}`
        )
        if (response.status === 204) {
          commit('callbackRemoveSchedulerTimeslot', timeslotId)
          Notify.create({
            message: 'La plage horaire a été supprimée avec succès.',
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite lors de la suppression.",
          color: 'red'
        })
        return Promise.reject(error)
      }
    }
  },
  getters: {
    getSchedulerTimeslots(state) {
      return state.schedulerTimeslots
    }
  }
}
